import { IconBase } from "./iconBase.js";
import { jsx } from "@emotion/react/jsx-runtime";
//#region src/arrowLeft.tsx
var ArrowLeft = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsx("path", {
		d: "M10.0606 18L4 12M4 12L10.0606 6M4 12H20",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}) : /* @__PURE__ */ jsx("path", {
		d: "M9.58984 5.41602C9.88563 5.17699 10.3205 5.1966 10.5938 5.47266C10.8668 5.74874 10.8816 6.18327 10.6396 6.47656L10.5879 6.5332L5.82324 11.25H20L20.0771 11.2539C20.4551 11.2925 20.75 11.6118 20.75 12C20.75 12.3882 20.4551 12.7075 20.0771 12.7461L20 12.75H5.82324L10.5879 17.4668L10.6396 17.5234C10.8816 17.8167 10.8668 18.2513 10.5938 18.5273C10.3205 18.8034 9.88563 18.823 9.58984 18.584L9.5332 18.5332L3.47266 12.5332C3.33037 12.3923 3.25 12.2002 3.25 12C3.25 11.7998 3.33038 11.6077 3.47266 11.4668L9.5332 5.4668L9.58984 5.41602Z",
		fill: "currentColor"
	})
});
//#endregion
export { ArrowLeft };
